import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconLayoutTop: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="layout-top, margin, padding"><path d="M3.75 20.25L3.75 7.75L20.25 7.75V20.25L3.75 20.25Z" stroke="currentColor" strokeWidth="1.5"/><path d="M3 3.75H21" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconLayoutTop;
